<div class="create-ai-assistant-form-view__wrap">
  <div class="db-first-half">
    <div class="fade-in-container">
      <h4 class="db-title  fade-in mb8">What product categories do you offer?</h4>
      <div class="db-desc-icon">
      <span class="db-desc">Our AI pre-filled the options to speed up your<br class="show-mobile"/> onboarding.<br class="hide-mobile"/>
        You can edit or keep the suggestions.
    </span>
        <i class="db-icon db-icon-ds-ai-generate mb8"></i>
      </div>
    </div>
    <div class="db-product-list mt32">
      <div *ngFor="let service of generatedServices; let i = index" class="fade-up">
        <input type="text" class="ds-input ds-input-black"
               [ngModel]="service"
               (ngModelChange)="onServiceChange($event, i)"
               [placeholder]="getPlaceholder(i)"/>
      </div>
    </div>
  </div>

  <div class="db-create-company-info-mobile first-step" *ngIf="!!isMobile">
    <button (click)="onGenerate()"
            class="ds-btn-ls"
            [ngClass]="{'ds-btn-disabled': inputValues.length < generatedServices.length,  'ds-btn-purple-blue': isMobile}">
      <ng-container *ngIf="!(builderInteractionsService.loading|async); else spinner">
        <img [src]="'assets/images/icons/ai-generate-white.svg'" alt=""/>
        <span>{{ 'text_generateYourWebsite' | dbText }}</span>
      </ng-container>
      <ng-template #spinner>
        <db-loading-circular-spinner></db-loading-circular-spinner>
      </ng-template>
    </button>
  </div>

</div>

<ng-template #fallbackContent>
  <div class="fallback-form">
    <div class="ds-input-wrap mb9">
      <span class="ds-fake-input ds-lazy-load"></span>
    </div>
    <div class="ds-input-wrap mb9">
      <span class="ds-fake-input ds-lazy-load"></span>
    </div>
    <div class="ds-input-wrap mb9">
      <span class="ds-fake-input ds-lazy-load"></span>
    </div>
    <div class="ds-input-wrap mb9">
      <span class="ds-fake-input ds-lazy-load"></span>
    </div>
  </div>
</ng-template>
